import { toast } from 'sonner';
import { isNil } from 'ramda';

// lang
import { __ } from '@wordpress/i18n';

/**
 * Handle info msg displaying
 *
 * @param {string} msg
 * @param {object} args
 *
 * @returns (void)
 */
const handleInfoAndDisplay = (msg, args = {}) => {
    const config = {
        'className': 'uniSonnerNotifications toastError',
        ...args
    }

    toast(isNil(msg) ? __('Info.', 'soundbetween') : msg, config);
};

export default handleInfoAndDisplay;